import { render, staticRenderFns } from "./reward_record_detail.vue?vue&type=template&id=6c7b4e5b&scoped=true"
import script from "./reward_record_detail.vue?vue&type=script&lang=js"
export * from "./reward_record_detail.vue?vue&type=script&lang=js"
import style0 from "./reward_record_detail.vue?vue&type=style&index=0&id=6c7b4e5b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7b4e5b",
  null
  
)

export default component.exports